import * as API from './';
import { OptimizationResultParam, OptimizationTasksParam, PlanDetailInfo } from '@/interfaces/api_interface';
import { PlanList, SimuLog, TaskInformation } from '@/prioritization/interface/interface';
export default {
    /**
     * 运行优化任务
     * @param params <object> 请求参数
     */
    runOptimization: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/runOptimization', params);
    },
    /**
     * 获取优化结果方法
     * @param params <OptimizationResultParam> 请求参数
     */
    getOptimizationResult: (params: OptimizationResultParam): Promise<{ data: PlanList[] }> => {
        return API.GET<{ data: PlanList[] }>('/taskmanager/getOptimizationResult', params);
    },
    getPlanDetailInfo: async (simuId: number | string, taskId: string, planId: number): Promise<PlanDetailInfo> => {
        return API.GET<PlanDetailInfo>('/taskmanager/getOptimizationResult', { simuid: simuId, taskid: taskId, planId: planId, resultType: 1 });
    },
    getRelatedOptimizationResult: (params: OptimizationResultParam): Promise<{ simu: number; data: PlanList[] }> => {
        return API.GET<{ simu: number; data: PlanList[] }>('/taskmanager/getRelatedOptimizationResult', params);
    },

    getLastSimulationTask: (params: OptimizationTasksParam): Promise<TaskInformation> => {
        return API.GET('/taskmanager/getSimuLastTasks', params);
    },
    /**
     * 运行优化任务
     * @param params <object> 请求参数
     */
    getSimuLog: (params: object): Promise<SimuLog> => {
        return API.GET('/taskmanager/getOptimizationLog', params);
    },

    /**
     * 运行优化任务
     * @param params <object> 请求参数
     */
    removeOptimizationTask: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/removeOptimizationTask', params);
    },

    /**
     * 获取
     * @param params <object> 请求参数
     */
    getConstruction: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/getConstruction', params);
    },
    saveDataToclickhouse: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/saveDataToclickhouse', params);
    },

    /**
     * 获取结果
     */
    getEconomyResult: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/getEconomyResult', params);
    },

    /**
     * 获取能效水平数据
     */
    getEnergyEvaluation: (params: object): Promise<unknown> => {
        // return new Promise((resolve,reject)=>{
        //     resolve({results:[{data:energyData.energyData}]});
        // })
        return API.GET('/taskmanager/getEnergyEvaluation', params);
    },
    /**
     * 获取环保评价数据
     */
    getEnvironmentalEvaluation: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/getEnvironmentalEvaluation', params);
    },
    /**
     * 资产负债表
     */
    getLiabilityAssetsResult: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/getLiabilityAssetsResult', params);
    },
    /**
     * 财务计划现金流量
     */
    getFinancialPlanCashFlowResult: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/getFinancialPlanCashFlowResult', params);
    },
    /**
     * 投资使用计划与资金筹措
     */
    getInvestPlanDataResult: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/getInvestPlanDataResult', params);
    },
    /**
     * 流动资金估算
     */
    getFlowCashEvaluteResult: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/getFlowCashEvaluteResult', params);
    },
    /**
     * 资产折旧与摊销估算
     */
    getAssetsDepreciationResult: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/getAssetsDepreciationResult', params);
    },
    /**
     * 总成本费用估算
     */
    getSumCostResult: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/getSumCostResult', params);
    },
    /**
     * 项目总投资现金流量
     */
    getSumInvestFlowCashResult: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/getSumInvestFlowCashResult', params);
    },
    /**
     * 项目资本金现金流量
     */
    getProjectCashFlowResult: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/getProjectCashFlowResult', params);
    },
    /**
     * 营业收入_税金_附加和增值税估算
     */
    getIncomeTaxResult: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/getIncomeTaxResult', params);
    },
    /**
     * 借款还本付息计划
     */
    getLoanRepaymentPlanResult: (params: object): Promise<unknown> => {
        return API.GET('/taskmanager/getLoanRepaymentPlanResult', params);
    },
    /**
     * 概览表
     */
    getOverviewResult: (
        params: object,
    ): Promise<{
        error: number;
        task_id: string;
        results: Array<{
            data: {
                项目动态总投资: number;
                年销售收入: number;
                平均年总成本费用: number;
                总投资收益率: number;
                资本金利润率: number;
                资本金内部收益率: number;
                所得税前投资内部收益率: number;
                所得税前投资财务净现值: number;
                所得税前投资回报期: number;
                所得税后投资内部收益率: number;
                所得税后投资财务净现值: number;
                所得税后投资回报期: number;
            };
            time: number;
        }>;
    }> => {
        return API.GET<{
            error: number;
            task_id: string;
            results: [
                {
                    data: {
                        项目动态总投资: number;
                        年销售收入: number;
                        平均年总成本费用: number;
                        总投资收益率: number;
                        资本金利润率: number;
                        资本金内部收益率: number;
                        所得税前投资内部收益率: number;
                        所得税前投资财务净现值: number;
                        所得税前投资回报期: number;
                        所得税后投资内部收益率: number;
                        所得税后投资财务净现值: number;
                        所得税后投资回报期: number;
                    };
                    time: number;
                },
            ];
        }>('/taskmanager/getOverviewResult', params);
    },
};
